import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'nf-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  boardGroupData: Array<any> = []; // 面板组数据
  filterColumnData: Array<any> = []; // 存放筛选表头数据
  filterGroupData: any = {}; // 存放筛选行数据
  filterPulseData: any = {}; // 存放筛选行数据
  localUser: Array<any> = []; // 存放本地存储面板用户
  progressData: any = {}; // 存放进度筛选条件
  @Input('nfBoardColumn') set ChangeColumn(data: any) {
    if (data) {
      this.filterColumnData = [];
      data.forEach((item, index) => {
        switch (item.type) {
          case 'name':
            const obj = {
              'id': item.id,
              'type': 'group',
              'title': '组'
            };
            this.filterColumnData.push(obj);
            break;
          default:
            this.filterColumnData.push(item);
            break;
        }
      });
    }
  }
  @Input('nfBoardGroup') set ChangeGroup(data: any) {
    if (data) {
      this.boardGroupData = data;
      this.filterGroupData = {
        'notSelected': this.boardGroupData,
        'selected': []
      };
    }
  }
  @Input('nfBoardPulse') set ChangePulse(data: any) {
    // 获取本地存储用户列表
    const user = localStorage.getItem('local_user');
    if (user) {
      this.localUser = JSON.parse(user);
    }
    this.filterPulseData = [];
    for (const key in this.filterColumnData) {
      if (this.filterColumnData.hasOwnProperty(key)) {
        switch (this.filterColumnData[key].type) {
          case 'text':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            break;
          case 'date':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            break;
          case 'status':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            break;
          case 'multiple-person':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            break;
          case 'dropdown':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            break;
          case 'progress':
            this.filterPulseData[this.filterColumnData[key].id] = this.handleFilterList(key, data);
            this.progressData = {
              'notSelected': [
                {
                  'id': 1,
                  'value': 20,
                  'symbol': '<'
                },
                {
                  'id': 2,
                  'value': 20,
                  'symbol': '>'
                },
                {
                  'id': 3,
                  'value': 50,
                  'symbol': '>'
                }
              ],
              'selected': []
            };
            break;
        }
      }
    }
  }
  constructor() { }

  ngOnInit() {
  }
  // 处理筛选列表项
  handleFilterList(key, data) {
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      for (const item in data[i].columnValues) {
        if (data[i].columnValues.hasOwnProperty(item)) {
          if (this.filterColumnData[key].id === item) {
            let o = {};
            // 针对人员组件特殊处理
            if (this.filterColumnData[key].type === 'multiple-person') {
              if (data[i].columnValues[item].personsAndTeams) {
                for (let k = 0; k < data[i].columnValues[item].personsAndTeams.length; k++) {
                  const id = data[i].columnValues[item].personsAndTeams[k].id;
                  o = this.localUser.filter(list => id.toString() === list.id)[0];
                  arr.push(o);
                }
              }
            } else {
              o = {
                'columnId': item,
                'pulseId': data[i].id,
                'value': data[i].columnValues[item]
              };
              arr.push(o);
            }
          }
        }
      }
    }
    arr = this.unique(arr);
    const obj = {
      'type': this.filterColumnData[key].type,
      'notSelected': arr,
      'selected': []
    };
    return obj;
  }
  // 筛选组
  filterNotSelectGroup(group) {
    this.filterGroupData.notSelected = this.filterGroupData.notSelected.filter(list => group.id !== list.id);
    this.filterGroupData.selected.push(group);
  }
  filterSelectGroup(group) {
    this.filterGroupData.selected = this.filterGroupData.selected.filter(list => group.id !== list.id);
    this.filterGroupData.notSelected.push(group);
  }
  // 选中操作
  filterNotSelect(columnId, pulse, type) {
    switch (type) {
      case 'multiple-person':
        this.filterPulseData[columnId].notSelected = this.filterPulseData[columnId].notSelected.filter(list => pulse.id !== list.id);
        this.filterPulseData[columnId].selected.push(pulse);
        break;
      default:
        this.filterPulseData[columnId].notSelected = this.filterPulseData[columnId].notSelected.filter(list => pulse.pulseId !== list.pulseId);
        this.filterPulseData[columnId].selected.push(pulse);
        break;
    }
  }
  // 取消选择操作
  filterSelect(columnId, pulse, type) {
    switch (type) {
      case 'multiple-person':
        this.filterPulseData[columnId].selected = this.filterPulseData[columnId].selected.filter(list => pulse.id !== list.id);
        this.filterPulseData[columnId].notSelected.push(pulse);
        break;
      default:
        this.filterPulseData[columnId].selected = this.filterPulseData[columnId].selected.filter(list => pulse.pulseId !== list.pulseId);
        this.filterPulseData[columnId].notSelected.push(pulse);
        break;
    }
  }
  // 筛选进度
  filterNotSelectProgress(item) {
    this.progressData.notSelected = this.progressData.notSelected.filter(list => item.id !== list.id);
    this.progressData.selected.push(item);
  }
  filterSelectProgress(item) {
    this.progressData.selected = this.progressData.selected.filter(list => item.id !== list.id);
    this.progressData.notSelected.push(item);
  }
  // 清除选中
  cleanFilter() {
    if (this.filterGroupData.selected.length > 0) {
      this.filterGroupData.selected.forEach((item, index) => {
        this.filterGroupData.notSelected.push(item);
      });
      this.filterGroupData.selected = [];
    }
    if (this.progressData.selected.length > 0) {
      this.progressData.selected.forEach((item, index) => {
        this.progressData.notSelected.push(item);
      });
      this.progressData.selected = [];
    }
    for (const pulse in this.filterPulseData) {
      if (this.filterPulseData.hasOwnProperty(pulse)) {
        if (this.filterPulseData[pulse].selected.length > 0) {
          for (let i = 0; i < this.filterPulseData[pulse].selected.length; i++) {
            this.filterPulseData[pulse].notSelected.push(this.filterPulseData[pulse].selected[i]);
          }
          this.filterPulseData[pulse].selected = [];
        }
      }
    }
  }
  // 数组去重
  unique(arr) {
    const res = new Map();
    return arr.filter((a) => !res.has(a) && res.set(a, 1));
  }
}
